import React from 'react';
import Head from 'next/head';
import { jsx as _jsx } from "react/jsx-runtime";
export const Helmet = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Head, {
    "data-id": "lib_react-helmet-async_Helmet_Head",
    children: children
  });
};